<script lang="ts">
  // Google tag manager cookie information:
  // https://developers.google.com/tag-platform/security/concepts/cookies
  import Page from "$lib/Page.svelte";
  import Button from "$lib/Button.svelte";
  import { versionDate } from "$lib/cookieConsent.svelte";
  import theTime from "$lib/utils/the-time";
  import NecessaryCookies from "./Necessary.svelte";
  import LeaddeskCookies from "./Leaddesk.svelte";
  import GoogleCookies from "./Google.svelte";
  import MetaCookies from "./Meta.svelte";
</script>

<Page
  class="cookie-page"
  data={{
    title: `Cookies og andre informasjonskapsler`,
    description: `Dette nettstedet, www.ishavskraft.no, bruker cookies og andre informasjonskapsler.`,
  }}
>
  <p class="text-[--fg-muted] font-600">
    <small
      >Gjeldende versjon datert: {theTime(versionDate).toLocaleDateString("nb", {
        dateStyle: "medium",
      })}</small
    >
  </p>

  <p>
    En informasjonskapsel (blant annet en «cookie») er en tekstfil eller datavariabel som en
    nettside kan lagre i nettleseren din. Når du besøker en nettside kan nettsiden lese denne
    informasjonskapselen.
  </p>
  <p>
    Nedenfor finner du informasjon om de mulige informasjonskapslene for dette nettstedet, www.<span
      class="whitespace-nowrap">ishavskraft</span
    >.no.
  </p>

  <div class="flex flex-wrap gap-2 items-center my-6">
    <p class="text-sm m-0"><em>Relatert informasjon:</em></p>
    <p class="m-0">
      <Button primary arrow class="text-start" href="/om/personvern"
        >Personvernpolicy for <small class="whitespace-nowrap">www.ishavskraft.no</small></Button
      >
    </p>
  </div>

  <h2><strong class="text-$lysning">Nødvendige</strong> informasjonskapsler</h2>

  <p>
    www.ishavskraft.no lagrer noen informasjonskapsler for at nettstedet skal fungere som nødvendig,
    f.eks. for at du skal kunne bestille alle våre produkter og bli presentert rett pris.
  </p>

  <NecessaryCookies />

  <h2><strong class="text-$lysning">Funksjonelle</strong> informasjonskapsler</h2>

  <p>
    Hvis du har godtatt cookies/informasjonskapsler for «Funksjonelle» får du tilgang til en chatbot
    levert av Leaddesk. Straks du åpner chatten med chatte-knappen lastes det da datakode for
    chatten som bruker noen informasjonskapsler så chatten skal fungere.
  </p>

  <LeaddeskCookies />

  <h2><strong class="text-$lysning">Markedsførings</strong> relaterte informasjonskapsler</h2>

  <p>
    Cookies for markedsføring brukes ikke før du har godtatt cookies/informasjonskapsler for
    «Markedsføring» på dette nettstedet. Da laster www.ishavskraft.no datakode fra Google og Meta
    (tidligere Facebook), som bruker flere informasjonskapsler. Ishavskraft bruker disse
    leverandørene for å kunne gjøre målrettet annonsering til de som med større sannsynlighet har
    behov for våre produkter.
  </p>

  <GoogleCookies />
  <MetaCookies />
</Page>

<style lang="postcss">
  :global(.cookie-page) {
    /* mark external links with outgoing arrow */
    & :global(a[href^="http"]::after) {
      content: " ↗";
    }

    & :global(details) {
      max-width: var(--w-prose);

      &:global([open]) {
        box-shadow: 0 1px;
        margin-block: 1em 2em;
        padding-block-end: 1em;
      }
    }

    & :global(table) {
      font-size: var(--text-sm);
    }
  }

  h2 {
    margin-block-start: var(--s-8);
  }
</style>
